var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _polygon, _path24, _path25, _polygon2, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _polygon3, _path39, _path40, _polygon4, _line, _polygon5, _path41, _path42, _g, _polygon6, _polyline, _path43, _path44, _circle, _path45, _path46, _path47, _circle2, _line2, _path48, _path49, _circle3, _path50, _path51, _circle4, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _circle5, _path61, _circle6, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _circle7, _path90, _circle8, _path91, _path92, _circle9, _path93, _circle10, _path94, _path95, _path96, _path97;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBighead7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 990",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "scale(1)",
    style: {
      transformOrigin: "center center"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M225.35,498c183.42,77.95,371.14,79.06,555.94,0,17.53-7.5,17.43-139.87,0-133.81-180.47,62.83-371.33,63.5-555.94,0C203.39,356.6,205.53,489.53,225.35,498Z",
    fill: "#592d3d",
    stroke: "#592d3d",
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M610,758.72c90.76,0,72,114.24,72.87,241.28H610Z",
    fill: "#CC734C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M632.74,831.87,610,870l11.38,130h31.76C653.91,819.73,632.74,831.87,632.74,831.87Z",
    fill: "#B56241"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M233.25,500c0-147.32,119.43-266.75,266.75-266.75S766.75,352.68,766.75,500A266.22,266.22,0,0,1,668.1,707.12q-8.21,6.68-16.94,12.69C591,758,515,758,446.39,751.89c-6.66-1-13.3-2.26-19.89-3.71-26.33-5.8-51.82-14.75-75.37-27.8Q342.4,715,334.2,708.76a199.59,199.59,0,0,1-15.8-13.38q-7.14-6.63-13.79-13.78A265.86,265.86,0,0,1,233.25,500Z",
    fill: "#CC734C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M269.61,634.48c.7,1.2,1.39,2.4,2.11,3.58.43.72.88,1.42,1.33,2.14.66,1.07,1.32,2.14,2,3.19.48.76,1,1.5,1.46,2.24.66,1,1.32,2,2,3,.51.76,1,1.52,1.56,2.28.66,1,1.32,1.92,2,2.88.54.77,1.1,1.53,1.65,2.3s1.34,1.85,2,2.77,1.15,1.53,1.73,2.29,1.37,1.8,2.07,2.7,1.19,1.51,1.79,2.26,1.41,1.76,2.12,2.63,1.23,1.49,1.85,2.23,1.44,1.72,2.17,2.57,1.27,1.47,1.91,2.2l2.22,2.5c.65.73,1.31,1.44,2,2.16.86.94,1.73,1.87,2.6,2.79l1.21,1.28c1.29,1.34,2.59,2.68,3.91,4l.26.27c1.29,1.28,2.6,2.55,3.91,3.81l1.58,1.5c.95.89,1.9,1.78,2.86,2.66l1.16,1.06c1,.94,2.09,1.86,3.14,2.78q4.9,4.27,10,8.19,8.19,6.24,16.93,11.62c23.55,13,49,22,75.37,27.8,6.59,1.45,13.23,2.7,19.89,3.71,42.1,3.75,87,5.18,129.28-3.08C508.45,729,185.59,612.74,388.8,257.48h0c-2.72,1.25-5.4,2.54-8.06,3.88l-.59.29c-1.22.61-2.44,1.24-3.65,1.88l-1,.53c-3.76,2-7.48,4.07-11.13,6.23l-.9.53c-1.16.69-2.31,1.39-3.46,2.1l-.87.54q-5.36,3.35-10.55,6.93l-1.08.75c-1.09.76-2.16,1.52-3.23,2.29l-.66.47q-3.27,2.39-6.46,4.84l-.62.48c-1,.78-2,1.58-3,2.39l-1.17.94c-1,.81-2,1.62-3,2.45l0,0c-2.11,1.75-4.19,3.55-6.24,5.37l-1.14,1-2.69,2.45L318,305q-4.28,4-8.37,8.17l-1.38,1.41c-.79.82-1.58,1.64-2.36,2.47-.46.49-.92,1-1.37,1.48q-2.06,2.2-4.06,4.46c-.45.51-.91,1-1.36,1.54-.71.81-1.41,1.63-2.11,2.45l-1.51,1.79c-.68.81-1.36,1.62-2,2.44-.54.66-1.08,1.33-1.61,2-1.07,1.33-2.12,2.66-3.16,4-.54.7-1.08,1.4-1.61,2.11s-1.2,1.59-1.79,2.4-1.07,1.45-1.59,2.18-1.13,1.55-1.68,2.33q-1.42,2-2.8,4.05c-.5.73-1,1.48-1.49,2.22s-1.1,1.66-1.64,2.5l-1.49,2.31-1.68,2.71c-.43.69-.86,1.38-1.28,2.07-.89,1.46-1.75,2.93-2.61,4.4l-1.22,2.16c-.54.95-1.08,1.91-1.61,2.87-.4.73-.8,1.46-1.19,2.19-.64,1.19-1.27,2.39-1.9,3.59l-1.2,2.34c-.64,1.28-1.28,2.55-1.91,3.84-.33.69-.67,1.39-1,2.09-.52,1.09-1,2.19-1.53,3.29-.31.66-.61,1.32-.91,2q-1.11,2.47-2.17,5c-.22.52-.43,1.05-.65,1.57-.53,1.27-1.05,2.54-1.56,3.82-.27.67-.53,1.34-.79,2-.5,1.26-1,2.53-1.45,3.8-.21.55-.42,1.1-.62,1.65q-.94,2.63-1.85,5.26l-.56,1.7q-.66,2-1.29,4l-.6,1.91c-.47,1.54-.93,3.08-1.37,4.63-.1.33-.2.66-.29,1q-.78,2.76-1.5,5.54c-.16.59-.3,1.19-.45,1.78-.35,1.39-.69,2.78-1,4.18l-.42,1.75c-.43,1.9-.85,3.8-1.24,5.71l-.15.77q-.51,2.55-1,5.1c-.11.61-.21,1.21-.32,1.82-.26,1.49-.51,3-.74,4.5-.08.51-.17,1-.24,1.52-.3,1.95-.57,3.91-.83,5.88l-.15,1.3c-.2,1.59-.38,3.19-.55,4.79-.06.6-.13,1.2-.19,1.81-.16,1.68-.31,3.37-.45,5.06,0,.35-.06.69-.08,1q-.22,3-.39,6.05c0,.53,0,1.07-.07,1.6q-.1,2.36-.18,4.71c0,.59,0,1.18,0,1.77,0,2.05-.08,4.11-.08,6.17,0,0,0,.07,0,.1,0,2.22,0,4.42.08,6.62,0,.76.06,1.52.08,2.28.05,1.47.1,2.94.17,4.41,0,.89.11,1.77.16,2.66.08,1.33.15,2.66.25,4,.07,1,.16,1.89.24,2.83.11,1.26.21,2.52.34,3.77.09,1,.21,1.94.31,2.91.14,1.21.27,2.43.42,3.64.12,1,.26,2,.39,2.95.16,1.18.32,2.37.5,3.55.15,1,.31,2,.47,3,.18,1.16.37,2.33.57,3.49.18,1,.36,2,.55,3,.21,1.15.43,2.3.65,3.44s.41,2,.62,3c.24,1.14.48,2.27.74,3.4s.44,2,.68,2.93c.26,1.13.54,2.25.82,3.36s.49,1.95.74,2.91c.3,1.12.6,2.23.91,3.34.26,1,.53,1.92.81,2.87.32,1.11.65,2.21,1,3.31s.58,1.89.88,2.84.7,2.19,1.06,3.28.62,1.87.94,2.8c.38,1.09.76,2.18,1.15,3.27.33.91.65,1.83,1,2.74l1.24,3.27c.35.89.69,1.79,1,2.68.44,1.09.89,2.19,1.34,3.28.36.86.71,1.73,1.08,2.59.47,1.12,1,2.22,1.45,3.33.37.82.73,1.65,1.1,2.47.52,1.16,1.07,2.3,1.6,3.44l1.08,2.3c.61,1.26,1.24,2.5,1.87,3.75.32.63.62,1.27.95,1.9q2.88,5.61,6,11.07C268.88,633.26,269.25,633.87,269.61,634.48Z",
    fill: "#B56241"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M233.25,500c0-147.32,119.43-266.75,266.75-266.75S766.75,352.68,766.75,500A266.22,266.22,0,0,1,668.1,707.12q-8.21,6.68-16.94,12.69C591,758,515,758,446.39,751.89c-6.66-1-13.3-2.26-19.89-3.71-26.33-5.8-51.82-14.75-75.37-27.8Q342.4,715,334.2,708.76a199.59,199.59,0,0,1-15.8-13.38q-7.14-6.63-13.79-13.78A265.86,265.86,0,0,1,233.25,500Z",
    fill: "none",
    stroke: "#592d3d",
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M386.12,758.72c-90.77,0-72,114.24-72.87,241.28h72.87Z",
    fill: "#CC734C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M367.23,831.87,390,870l-11.39,130H346.88C346.07,819.73,367.23,831.87,367.23,831.87Z",
    fill: "#B56241"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M619.47,1070H380.53a13.28,13.28,0,0,1-13.27-13.28V772a13.28,13.28,0,0,1,13.27-13.28H613.76c13.09,0,19,7.66,19,19.88v278.08A13.28,13.28,0,0,1,619.47,1070Z",
    fill: "#CC734C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M629.05,766.62a19.33,19.33,0,0,1-2.51-4,17.25,17.25,0,0,0-8.28-3.51,28.88,28.88,0,0,0-4.5-.34H380.53A13.28,13.28,0,0,0,367.26,772c29,10.42,83.29,16.24,132.74,16.24C563.06,788.24,604.38,778.89,629.05,766.62Z",
    fill: "#B56241"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M610,758.72c90.76,0,72,114.24,72.87,241.28H632.74",
    fill: "none",
    stroke: "#592d3d",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M386.12,758.72c-90.77,0-72,114.24-72.87,241.28h50.07",
    fill: "none",
    stroke: "#592d3d",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M380.53,758.82l233.23-.1",
    fill: "none",
    stroke: "#592d3d",
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M380.53,1070H497.15C388,1070,396.24,838.82,367.26,838.82v217.86A13.28,13.28,0,0,0,380.53,1070Z",
    fill: "#B56241"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M361.26,860.85c-.19-3.67-.11-7.34.05-11s.47-7.35.86-11c.2-1.84.4-3.67.65-5.51s.49-3.67.85-5.51a44.18,44.18,0,0,1,3.59-11,44.18,44.18,0,0,1,3.59,11c.36,1.84.62,3.67.85,5.51s.45,3.67.65,5.51c.38,3.67.68,7.34.85,11s.25,7.34.06,11Z",
    fill: "#592d3d"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M632.74,870v8c.26,34,.26,69,0,102.75,0,2.87,0,5.72,0,8.53v67.41A13.28,13.28,0,0,1,619.47,1070H380.53a13.28,13.28,0,0,1-13.27-13.28V998.52c0-2.51,0-5.07,0-7.65-.25-34.87-.25-69.87,0-105.3V860.85",
    fill: "none",
    stroke: "#592d3d",
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M626.74,870c-.19-4.17-.1-8.35.06-12.53s.47-8.35.85-12.53c.2-2.09.41-4.18.65-6.27s.49-4.17.85-6.26a55.09,55.09,0,0,1,3.59-12.53,55.09,55.09,0,0,1,3.59,12.53c.36,2.09.62,4.18.85,6.26s.45,4.18.65,6.27c.38,4.18.69,8.35.85,12.53s.25,8.36.06,12.53Z",
    fill: "#592d3d"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M570.68,842.45C570.9,833,582.9,829,588.9,835a10.61,10.61,0,1,1-15.16,14.85A10.4,10.4,0,0,1,570.68,842.45Z",
    fill: "#592d3d"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M408.11,842.15C407.9,834,416.9,830,422.9,833c8,3,8,14,0,19-4,2-8,0-11.75-2.48A10.39,10.39,0,0,1,408.11,842.15Z",
    fill: "#592d3d"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M500,831.77a27.13,27.13,0,0,1,1.5,5.84,42.47,42.47,0,0,1,.49,5.84l.3,11.69c.09,3.89.21,7.79.25,11.69l.17,11.67c.23,15.57.22,31.16.28,46.74s.18,31.16,0,46.74c-.09,7.79-.3,15.58-.53,23.37-.1,3.89-.29,7.79-.67,11.68a92.5,92.5,0,0,1-1.77,11.69,92.5,92.5,0,0,1-1.77-11.69c-.38-3.89-.57-7.79-.67-11.68-.23-7.79-.44-15.58-.53-23.37-.2-15.58,0-31.16,0-46.74s0-31.15.18-46.73l.17-11.7.33-11.68.33-11.68a44.11,44.11,0,0,1,.5-5.84A27.13,27.13,0,0,1,500,831.77Z",
    fill: "#B56241"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M425.22,883a18.51,18.51,0,0,1,4.67-1.5,29.75,29.75,0,0,1,4.68-.5l9.35-.33,18.7-.41c12.46-.19,24.91-.24,37.38-.27s24.93-.16,37.39,0c6.23.09,12.46.3,18.7.53,3.11.11,6.23.3,9.34.67a61.34,61.34,0,0,1,9.35,1.78,59.17,59.17,0,0,1-9.35,1.77c-3.11.38-6.23.57-9.34.67-6.24.23-12.47.43-18.7.52-12.46.19-24.92,0-37.39,0s-24.93,0-37.4-.15c-6.23-.06-12.46-.26-18.68-.5l-9.35-.34a29.5,29.5,0,0,1-4.67-.5A18.45,18.45,0,0,1,425.22,883Z",
    fill: "#B56241"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M442.41,914.38a12.51,12.51,0,0,1,3.74-1.11,18.35,18.35,0,0,1,3.62-.15c2.39.1,4.78.16,7.17.21,4.78.11,9.56.15,14.34.17,9.63,0,19.09.08,28.76-.21s19.26-.43,28.88-.39c4.81,0,9.62.13,14.42.24a70.37,70.37,0,0,1,7.23.47,38.17,38.17,0,0,1,7.27,1.53,36.56,36.56,0,0,1-7.16,2,61.08,61.08,0,0,1-7.21.86c-4.82.35-9.64.65-14.45.82-9.64.36-19.27.32-28.88.45-4.81,0-9.61.22-14.48.1s-9.69-.13-14.52-.31-9.68-.58-14.5-1.08c-2.42-.27-4.82-.57-7.23-.9a16.82,16.82,0,0,1-3.57-.84A11.51,11.51,0,0,1,442.41,914.38Z",
    fill: "#B56241"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M438.93,949.87a13.07,13.07,0,0,1,3.82-1.5,19.13,19.13,0,0,1,3.82-.49l7.63-.32c5.09-.18,10.19-.33,15.28-.41C479.66,947,489.84,947,500,947s20.36-.17,30.54,0c5.09.09,10.18.3,15.27.53a72.73,72.73,0,0,1,7.63.66A41.2,41.2,0,0,1,561.1,950a41.25,41.25,0,0,1-7.63,1.77,70.34,70.34,0,0,1-7.64.67c-5.09.23-10.18.44-15.27.53-10.18.2-20.37.06-30.55,0s-20.36-.06-30.54-.25c-5.09-.1-10.19-.28-15.28-.49l-7.63-.37a19.33,19.33,0,0,1-3.82-.5A12.85,12.85,0,0,1,438.93,949.87Z",
    fill: "#B56241"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "547.85 847.98 505.72 813.61 580.35 758.82 419.65 758.82 494.28 813.61 452.15 847.98 414.52 791.48 414.52 869.96 588.78 869.96 588.78 786.52 547.85 847.98",
    fill: "#B56241"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M616.66,758.16l-42.73.1a119.49,119.49,0,0,1-1.43,13.48,63.7,63.7,0,0,1-1.74,6.34c-2.34,6.49-17.26,12-21.49,16.73a48.22,48.22,0,0,1-4.5,4.43c-25.17,18.2-65.17,19.2-89.48-.58a51.36,51.36,0,0,1-7.11-7.61c-4.23-5.56-16.4-11.59-18.1-18.94a60,60,0,0,1-1.08-6.59,63.55,63.55,0,0,1-.36-6.8s-45.21-.56-45.21-.56a13.28,13.28,0,0,0-13.28,13.27v284.69a13.28,13.28,0,0,0,13.28,13.27H622.36a13.27,13.27,0,0,0,13.27-13.27V778C635.63,765.82,629.75,758.16,616.66,758.16Z",
    fill: "#ffffff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M612.84,758.16c63.54,0,88.52,43.39,78.9,272-18.74,6.7-55.91,4.59-55.91,4.59Z",
    fill: "#ffffff"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "451.06 855.4 499.51 831.31 548.09 855.4 511.03 812.38 467.14 813.21 451.06 855.4",
    fill: "#E2E2E2"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M635.63,831.31s-22.79,84.54-19.31,234l33.21-31,3.58-137.58C647.49,824.5,635.63,831.31,635.63,831.31Z",
    fill: "#E2E2E2"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M389,758.16c-61.78,0-88.88,56.45-80.75,245.48,22.42,9.91,56.19,5.58,56.19,5.58Z",
    fill: "#ffffff"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M306.94,957.49q.26,20.46,1.21,43.48c15.27.73,43.69.88,57.11,0l4.18-42.81C358.67,956.9,323.66,956.49,306.94,957.49Z",
    fill: "#E2E2E2"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M370.12,831.31l-.5,177.69-13.35.9C353.3,860.85,370.12,831.31,370.12,831.31Z",
    fill: "#E2E2E2"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M612.84,758.16c67.42,0,78.45,56.28,78.9,133.78v138.22s-50,5.53-55.91,4.59l-.1-142.11",
    fill: "none",
    stroke: "#592d3d",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M389,758.16c-25.73,0-43.52,8.12-55.71,22.44-19.45,22.87-24.63,61.54-25,108.27v123.77c12.06,3.32,61.36-3.64,61.36-3.64l.49-118.6",
    fill: "none",
    stroke: "#592d3d",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M372.6,1011.24c-1.83,2.61-73.77,1.92-74.67,0s-2.19-37.5,0-41c1.8-2.88,72.11-2.27,74.67,0S374.43,1008.63,372.6,1011.24Z",
    fill: "#ffffff",
    stroke: "#592d3d",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M383.43,1069.39H500c-109.19,0-100.91-231.14-129.89-231.14v217.87A13.28,13.28,0,0,0,383.43,1069.39Z",
    fill: "#E2E2E2"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M364.15,860.29c-.19-3.67-.11-7.35.06-11s.47-7.34.85-11c.2-1.83.41-3.67.65-5.51s.49-3.67.85-5.5a44.05,44.05,0,0,1,3.59-11,44.05,44.05,0,0,1,3.59,11c.36,1.83.62,3.67.85,5.5s.45,3.68.65,5.51q.58,5.52.86,11c.16,3.67.24,7.35,0,11Z",
    fill: "#592d3d"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M635.63,869.4v8c.26,34,.26,69,0,102.76,0,2.87,0,5.72,0,8.53v67.41a13.27,13.27,0,0,1-13.27,13.27H383.43a13.28,13.28,0,0,1-13.28-13.27V990.3c-.26-34.86-.26-69.86,0-105.3V860.29",
    fill: "none",
    stroke: "#592d3d",
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M697.42,970.24c2.22,2.26,1.59,38.39,0,41s-64,1.92-64.77,0-1.9-37.5,0-41c.27-.5,2.28-.89,5.45-1.18",
    fill: "#ffffff",
    stroke: "#592d3d",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M678.92,968.3c3.8.3,15-1.18,15.42-.76",
    fill: "#ffffff"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M678.92,968.3a23.67,23.67,0,0,1,1.88-2.16,12.13,12.13,0,0,1,1.78-1.47,12.74,12.74,0,0,1,1.81-1c.61-.29,1.22-.54,1.83-.79a24.1,24.1,0,0,1,3.79-1.18,15.85,15.85,0,0,1,2-.31c.36,0,.73,0,1.17,0,.25,0,.46,0,.82,0,.12,0,.44,0,.71.07l.35,0,.49.11.25.06.2.06.57.21a6.45,6.45,0,0,1,2,1.37l4.2,4.29-8.65,8.48-4.12-4.37a5.73,5.73,0,0,0,1.91,1.32c.18.08.36.14.54.2l.17,0,.19.05a2.34,2.34,0,0,0,.38.09l.19,0h0c.1,0,.26,0,.22,0s-.07,0-.15,0l-.75,0c-.57,0-1.19,0-1.82,0a26.27,26.27,0,0,1-3.92-.53c-.67-.15-1.34-.3-2-.49a12.56,12.56,0,0,1-2-.72,10,10,0,0,1-2.08-1.32A8.19,8.19,0,0,1,678.92,968.3Z",
    fill: "#592d3d"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "592.51 763.64 517.84 818.45 559.98 852.83 619.4 763.59 592.51 763.64",
    fill: "#E2E2E2"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M629.63,869.4c-.19-4.18-.1-8.36.06-12.53s.47-8.36.86-12.53c.2-2.09.4-4.18.64-6.27s.49-4.18.86-6.27a54.83,54.83,0,0,1,3.58-12.53,54.37,54.37,0,0,1,3.59,12.53c.36,2.09.63,4.18.85,6.27s.45,4.18.65,6.27c.39,4.17.69,8.35.85,12.53s.26,8.35.06,12.53Z",
    fill: "#592d3d"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M383.43,758.26l233.23-.1",
    fill: "none",
    stroke: "#592d3d",
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "529.39 835.55 507.04 813.21 484.7 835.55 495.68 846.53 485.96 953.16 506.7 969.33 528.12 953.16 518.41 846.53 529.39 835.55",
    fill: "#E2E2E2"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 500.04,
    y1: 813.21,
    x2: 500.04,
    y2: 1069.39,
    fill: "none",
    stroke: "#592d3d",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: "6px"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "500.04 813.21 522.39 828.55 500.04 850.9 477.7 828.55 500.04 813.21",
    fill: "#633749"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M419.62,758.8s43.27,39.34,74.66,54.81C479,838.82,452.15,848,452.15,848l-59.43-89.23Z",
    fill: "#ffffff",
    stroke: "#592d3d",
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M580.38,758.8S541,800,505.72,813.61c10,20.28,42.13,34.37,42.13,34.37l59.43-89.23Z",
    fill: "#ffffff",
    stroke: "#592d3d",
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 30)"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "478.96 946.16 499.7 962.33 521.12 946.16 511.12 836.38 488.96 836.38 478.96 946.16",
    fill: "#633749"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "477.7 828.55 488.68 839.53 478.96 946.16 499.7 962.33 521.12 946.16 511.41 839.53 522.39 828.55",
    fill: "none",
    stroke: "#592d3d",
    strokeMiterlimit: 10,
    strokeWidth: "8px"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M638.1,969.06c7.51-.71,21.51-.89,34-.67",
    fill: "#ffffff"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M637.54,963.08a50.92,50.92,0,0,1,8.84-.47c2.9.07,5.78.3,8.66.65,1.43.18,2.87.37,4.3.61a43.36,43.36,0,0,1,4.29.85,27.53,27.53,0,0,1,8.5,3.67,30.13,30.13,0,0,1-8.52,3.5c-1.41.36-2.82.63-4.23.86s-2.81.47-4.21.69c-2.8.42-5.59.78-8.35,1s-5.52.5-8.16.54l-6,.1-1-11.13Z",
    fill: "#592d3d"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 515.77,
    cy: 982.93,
    r: 4.8,
    fill: "#592d3d"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M490.89,836.19c-.05-.06,0,0,0,0l.07.05a.88.88,0,0,1,.17.12l.38.29c.25.21.52.42.78.65.53.45,1.09.93,1.7,1.39s1.27.9,2,1.42a27.37,27.37,0,0,1,2.71,2.33,5.61,5.61,0,0,1-3.13,2.43,9.41,9.41,0,0,1-3.7.27,11,11,0,0,1-3.63-1,9.72,9.72,0,0,1-1.65-1,8.85,8.85,0,0,1-.77-.63c-.12-.11-.25-.23-.37-.36l-.2-.21-.25-.29Z",
    fill: "#592d3d"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M271.4,576.82c-1-28.36,18-52.36,43.28-63.56a62.37,62.37,0,0,1,8.16-2.7,70,70,0,0,1,42.21,2.68A71.67,71.67,0,0,1,374,517.4c29.53,15.88,42.79,53.25,31.36,83.46a61.68,61.68,0,0,1-4.18,8.82,54.68,54.68,0,0,1-17.51,20.83,69.25,69.25,0,0,1-7.85,5c-27.38,13-64.38,9-86.45-11.4a69.35,69.35,0,0,1-6.11-7.47,64.89,64.89,0,0,1-5.57-9.5A55.78,55.78,0,0,1,272,585.39,75.67,75.67,0,0,1,271.4,576.82Z",
    fill: "#B56241"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M269.77,558.47c-1-28.36,18-52.36,43.28-63.56a62.23,62.23,0,0,1,8.15-2.7,70,70,0,0,1,42.22,2.68,71.54,71.54,0,0,1,8.92,4.16c29.53,15.89,42.79,53.25,31.36,83.46a59.6,59.6,0,0,1-4.18,8.82,63.85,63.85,0,0,1-4.71,7.8,64.78,64.78,0,0,1-5.68,7,63.08,63.08,0,0,1-7.12,6.07,68.37,68.37,0,0,1-7.85,5c-27.38,13-64.38,9-86.44-11.4a67.24,67.24,0,0,1-6.11-7.47,65,65,0,0,1-5.58-9.5A55.59,55.59,0,0,1,270.32,567,71.3,71.3,0,0,1,269.77,558.47Z",
    fill: "#ffffff",
    stroke: "#592d3d",
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 338.51,
    cy: 559.08,
    r: 12.24,
    fill: "#592d3d"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 715.03,
    y1: 559.08,
    x2: 603.4,
    y2: 559.08,
    fill: "none",
    stroke: "#592d3d",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: "16px"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M627,574.16a114.14,114.14,0,0,1,13.07-1.56c4.36-.3,8.72-.43,13.08-.44s8.71.14,13.07.43a114.34,114.34,0,0,1,13.08,1.57,112.18,112.18,0,0,1-13.08,1.58q-6.54.43-13.07.42t-13.08-.43A112,112,0,0,1,627,574.16Z",
    fill: "#592d3d"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M243.89,489.13c5.64,15.83,20.9,24.06,33.4,26.94,13.06-20.24,56.65-28.92,89.37-17.44,27.8,5-10.81-25.57-72.47-9-2.31.85-14.56,2.95-30.28-9.19-2.19-1.69,4.68,13.71,12.5,20C265.06,500.21,263.2,500.22,243.89,489.13Z",
    fill: "#592d3d",
    fillRule: "evenodd"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 499.7,
    cy: 642.93,
    r: 53.95,
    fill: "#592d3d"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M491.21,663.39c-14.07-3.37-27.62,1-33.45,9.87a48.46,48.46,0,0,0,52.82,20.14,49.33,49.33,0,0,0,6-2C517.93,679.39,507.08,667.18,491.21,663.39Z",
    fill: "#f28195"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M478.65,652l.8,0h.65c.43,0,.84,0,1.25.06a17.92,17.92,0,0,1,2.44.35,21,21,0,0,1,4.74,1.53,18.15,18.15,0,0,1,7.78,6.65,17.17,17.17,0,0,1,2.77,9.28,14.75,14.75,0,0,1-2.69,8.47c-1.3-2.76-2.24-5.2-3.31-7.29a24,24,0,0,0-1.62-2.87,12.38,12.38,0,0,0-1.95-2.21,13,13,0,0,0-4.82-2.66,24.72,24.72,0,0,0-2.85-.69c-.49-.07-1-.16-1.47-.22l-.73-.07-.33,0c-.08,0-.26,0-.19,0Z",
    fill: "#592d3d"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 499.7,
    cy: 642.93,
    r: 53.95,
    fill: "none",
    stroke: "#592d3d",
    strokeMiterlimit: 10,
    strokeWidth: "8px"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M558.73,399.34c-12.86,24-60,37.44-63.83,31.42-4.29-6.73,37.85-55.32,13.9-106.14",
    fill: "#B56241"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M784,342.85c-5.1-5.1-31.06,1.83-57.19-.23A281,281,0,0,0,505.63,228.28c-2.44-20.48-.75-37.68-2.61-40.1-2.49-3.22-15.49,12.68-18.87,31-11.91-15-32.14-23-32.72-18.8-.38,2.68,7.44,14.09,14.81,29.9-111.6,13.47-203.08,92.26-235.08,197-13.86,11.92-26.86,20.34-27,25.69-.27,9.92,39.31,9.36,56.58,7.82v-.06c60.65-2,179-13.78,236.42-72.89C491.64,406.93,481.47,421,483.43,424c3,4.67,38.32-5.19,50.07-23.24,48,19.59,139.49,43.16,219-16.16l-.22-.43C766.77,372.06,790.35,349.25,784,342.85Z",
    fill: "#A56941"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M726.85,348.62c-5.4.24-10.66.11-16-.14s-10.59-.67-15.87-1.26c-2.64-.29-5.28-.6-7.91-1s-5.27-.72-7.89-1.23a76.91,76.91,0,0,1-15.58-4.54,91.87,91.87,0,0,1,16-2.62c2.63-.22,5.26-.37,7.89-.48l7.88-.34c5.25-.22,10.49-.34,15.72-.45s10.48-.12,15.62,0Z",
    fill: "#592d3d"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M236.6,430s0,.24,0,.39l-.12.53-.28,1.11c-.21.75-.43,1.52-.66,2.29-.47,1.55-1,3.14-1.54,4.75s-1.06,3.28-1.77,5a20.6,20.6,0,0,1-1.38,2.6,17.91,17.91,0,0,1-2.07,2.77,13.14,13.14,0,0,1-3.72-5.47,16.11,16.11,0,0,1-.76-2.9c-.21-1-.31-2-.43-2.95a30,30,0,0,1,0-6,24.44,24.44,0,0,1,.48-3c.12-.5.25-1,.41-1.51a7.84,7.84,0,0,1,.27-.77c.1-.28.18-.48.36-.9Z",
    fill: "#592d3d"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M260.74,460.82v-.06c17-.56,38.63-1.9,62.14-4.84,2.63-55.92,22-121.58,65.92-198.44h0L382,254.23A282.15,282.15,0,0,0,231.16,427.31c-13.86,11.92-26.86,20.34-27,25.69C203.89,462.92,243.47,462.36,260.74,460.82Z",
    fill: "#8D5638"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M784,342.85c-5.1-5.1-31.06,1.83-57.19-.23A281,281,0,0,0,505.63,228.28c-2.44-20.48-.75-37.68-2.61-40.1-2.49-3.22-15.49,12.68-18.87,31-11.91-15-32.14-23-32.72-18.8-.38,2.68,7.44,14.09,14.81,29.9-111.6,13.47-203.08,92.26-235.08,197-13.86,11.92-26.86,20.34-27,25.69-.27,9.92,39.31,9.36,56.58,7.82v-.06c60.65-2,179-13.78,236.42-72.89C491.64,406.93,481.47,421,483.43,424c3,4.67,38.32-5.19,50.07-23.24,48,19.59,139.49,43.16,219-16.16l-.22-.43C766.77,372.06,790.35,349.25,784,342.85Z",
    fill: "none",
    stroke: "#592d3d",
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M505.93,244.31a367.42,367.42,0,0,0-42.48,4.94c-3.48.67-6.95,1.41-10.44,2.05s-6.9,1.61-10.35,2.41l-10.26,2.72c-3.4,1-6.77,2.08-10.15,3.12a314.12,314.12,0,0,0-39.43,15.73,348.31,348.31,0,0,0-37.25,21,183.85,183.85,0,0,1,35.08-25.14,219.23,219.23,0,0,1,39.76-17.29c3.48-1,6.94-2.09,10.42-3.05s7-1.82,10.55-2.6,7.1-1.4,10.66-2,7.15-1.07,10.73-1.52A190,190,0,0,1,505.93,244.31Z",
    fill: "#ffffff"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M427.29,501.13l-13-4.39-31.2-10.54-37.6-12.71-32.49-11c-5.27-1.78-10.51-3.68-15.81-5.34l-.22-.08a10,10,0,0,0-5.32,19.29l13,4.39,31.2,10.54,37.6,12.7,32.49,11c5.26,1.78,10.5,3.67,15.81,5.34l.22.08a10,10,0,0,0,5.32-19.29Z",
    fill: "#592d3d"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M697.18,453.9,684.46,459l-30.54,12.31-36.81,14.84L585.3,499q-7.74,3.12-15.47,6.24l-.22.08c-2.51,1-4.56,2.17-6,4.6a10.18,10.18,0,0,0-1,7.71,10.06,10.06,0,0,0,4.6,6c2.22,1.18,5.26,2,7.7,1l12.73-5.13,30.54-12.31L655,492.33l31.81-12.82c5.15-2.08,10.32-4.15,15.47-6.24l.22-.09c2.51-1,4.56-2.17,6-4.59a10,10,0,0,0-3.59-13.69c-2.22-1.17-5.27-2-7.71-1Z",
    fill: "#592d3d"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1)",
    style: {
      transformOrigin: "center center"
    }
  }, _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 491.44,
    cy: 157.14,
    r: 47.48,
    fill: "#89D86F"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M491.44,204.62a47.47,47.47,0,0,0,46.46-57.31c-30.78-4.77-62.7-2-93.77,6-.1,1.26-.17,2.53-.17,3.82A47.48,47.48,0,0,0,491.44,204.62Z",
    fill: "#7DC462"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 491.44,
    cy: 157.14,
    r: 47.48,
    fill: "none",
    stroke: "#592d3d",
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M240.26,423.13a254.67,254.67,0,0,1,6.54-57.5q1.29-5.55,2.81-11c2.9-32.3,20-58.94,42.86-82.73,4.76-3.81,5.71-12.37,10.47-17.13,16.18-14.27,30.45-28.55,48.53-40,74.22-47.58,172.23-73.27,251.21-29.5,16.17,8.56,34.25,13.32,47.57,24.74,25.7,21.88,43.77,47.58,69.47,68.51,22.83,19,26.64,49.48,34.74,76.07q1.53,5.44,2.81,11a254.67,254.67,0,0,1,6.54,57.5Z",
    fill: "#89D86F"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M246.8,365.63a254.67,254.67,0,0,0-6.54,57.5h83C321.7,342.47,301,275.11,406,193,330.68,221.59,262.05,284.38,246.8,365.63Z",
    fill: "#7DC462"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M258.18,321.12a109.41,109.41,0,0,0-8.57,33.51q-1.52,5.44-2.81,11a254.67,254.67,0,0,0-6.54,57.5H440.31a827.17,827.17,0,0,1,127.59,0H763.81a254.67,254.67,0,0,0-6.54-57.5q-1.29-5.55-2.81-11c-3.46-11.37-6.15-23.44-9.86-35C582.71,259.73,419,261,258.18,321.12Z",
    fill: "#7DC462"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M240.26,423.13a254.67,254.67,0,0,1,6.54-57.5q1.29-5.55,2.81-11c2.9-32.3,20-58.94,42.86-82.73,4.76-3.81,5.71-12.37,10.47-17.13,16.18-14.27,30.45-28.55,48.53-40,74.22-47.58,172.23-73.27,251.21-29.5,16.17,8.56,34.25,13.32,47.57,24.74,25.7,21.88,43.77,47.58,69.47,68.51,22.83,19,26.64,49.48,34.74,76.07q1.53,5.44,2.81,11a254.67,254.67,0,0,1,6.54,57.5Z",
    fill: "none",
    stroke: "#592d3d",
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M225.35,356.43c183.42-78,371.14-79.06,555.94,0,17.53,7.5,17.43,139.87,0,133.81-180.47-62.83-371.33-63.5-555.94,0C203.39,497.79,205.53,364.86,225.35,356.43Z",
    fill: "#89D86F"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M751.33,443.71a43.58,43.58,0,0,1,1.35,9.9c.09,3.27-.11,6.52-.26,9.78l-.36,4.87c-.16,1.62-.32,3.24-.52,4.85-.4,3.23-.89,6.44-1.59,9.61l-7.87-1.41c.44-3.17,1-6.31,1.64-9.45l1-4.71,1-4.7c.74-3.13,1.37-6.27,2.22-9.4A53.94,53.94,0,0,1,751.33,443.71Z",
    fill: "#592d3d"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M749.91,342.47a175.32,175.32,0,0,1,3.63,19c.43,3.19.78,6.39,1.09,9.59s.49,6.42.66,9.63c.26,6.42.37,12.84.06,19.25a114.35,114.35,0,0,1-2.45,19.11c-1-6.39-1.67-12.7-2.32-19s-1.21-12.55-2.05-18.78c-.39-3.12-.83-6.22-1.3-9.32s-1-6.19-1.52-9.27c-1.07-6.17-2.3-12.29-3.59-18.41Z",
    fill: "#592d3d"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M668.78,322c7.56,42.87,6.71,89.49,0,138.73",
    fill: "none",
    stroke: "#592d3d",
    strokeMiterlimit: 10,
    strokeWidth: "8px"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M598.19,307.61c5.15,42.9,4.57,89.55,0,138.83",
    fill: "none",
    stroke: "#592d3d",
    strokeMiterlimit: 10,
    strokeWidth: "8px"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M533.85,356.47a172.75,172.75,0,0,1,2.37,20.68c.4,6.9.52,13.8.65,20.71l0,10.36c0,3.45,0,6.9-.12,10.35-.15,6.9-.4,13.8-.87,20.69l-8-.4c.22-6.87.57-13.73.94-20.59l1.21-20.57c.46-6.86.82-13.73,1.35-20.6S532.69,363.36,533.85,356.47Z",
    fill: "#592d3d"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M535.93,299.88a58.54,58.54,0,0,1,.28,6.35c0,1.06-.05,2.12-.08,3.18L536,312.6c-.17,2.12-.32,4.25-.68,6.38a22.42,22.42,0,0,1-2.08,6.41,23.29,23.29,0,0,1-2.7-6.21c-.57-2.08-.93-4.16-1.31-6.25l-.49-3.12c-.13-1.05-.28-2.09-.39-3.13a55,55,0,0,1-.35-6.29Z",
    fill: "#592d3d"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M467.76,299.65c.35,43,.31,89.67,0,139",
    fill: "none",
    stroke: "#592d3d",
    strokeMiterlimit: 10,
    strokeWidth: "8px"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M403.38,306.18c-2.06,43-1.83,89.73,0,139.11",
    fill: "none",
    stroke: "#592d3d",
    strokeMiterlimit: 10,
    strokeWidth: "8px"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M333.37,391.65a161.31,161.31,0,0,1,2.71,16.78c.63,5.59,1.09,11.17,1.65,16.75l1.51,16.73c.47,5.57.93,11.15,1.25,16.74l-8,.64c-.58-5.61-.93-11.24-1.18-16.87-.13-2.82-.2-5.64-.28-8.46l-.1-8.46c0-5.64.05-11.29.35-16.93A117.52,117.52,0,0,1,333.37,391.65Z",
    fill: "#592d3d"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M340.48,320.18c-.25,3.65-.64,7.28-1.05,10.91l-.66,5.45-.72,5.45c-.54,3.64-.95,7.28-1.6,10.93a67.39,67.39,0,0,1-2.8,10.92,55.71,55.71,0,0,1-2-11.14c-.3-3.72-.32-7.42-.38-11.14l0-5.56c.06-1.86.11-3.71.2-5.56.2-3.71.49-7.41,1-11.09Z",
    fill: "#592d3d"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M264.86,340.45c-6.86,43-6.09,89.85,0,139.3",
    fill: "none",
    stroke: "#592d3d",
    strokeMiterlimit: 10,
    strokeWidth: "8px"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M753.07,434.58a3.75,3.75,0,1,0-3.75-3.75,3.8,3.8,0,0,0,3.75,3.75Z",
    fill: "#592d3d"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M758.28,341.38c10,42.84,8.85,89.43,0,138.64",
    fill: "none",
    stroke: "#7DC462",
    strokeMiterlimit: 10,
    strokeWidth: "8px"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M681,320c7.56,42.87,6.71,89.49,0,138.74",
    fill: "none",
    stroke: "#7DC462",
    strokeMiterlimit: 10,
    strokeWidth: "8px"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M610.38,305.45c5.15,42.9,4.57,89.55,0,138.83",
    fill: "none",
    stroke: "#7DC462",
    strokeMiterlimit: 10,
    strokeWidth: "8px"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M544.06,297.82c2.74,42.92,2.44,89.61,0,138.92",
    fill: "none",
    stroke: "#7DC462",
    strokeMiterlimit: 10,
    strokeWidth: "8px"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M479.8,297.16c.34,42.95.31,89.67,0,139",
    fill: "none",
    stroke: "#7DC462",
    strokeMiterlimit: 10,
    strokeWidth: "8px"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M415.34,303.53c-2.06,43-1.83,89.73,0,139.11",
    fill: "none",
    stroke: "#7DC462",
    strokeMiterlimit: 10,
    strokeWidth: "8px"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M348.41,317c-4.46,43-4,89.79,0,139.21",
    fill: "none",
    stroke: "#7DC462",
    strokeMiterlimit: 10,
    strokeWidth: "8px"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M276.74,337.64c-6.86,43-6.09,89.85,0,139.3",
    fill: "none",
    stroke: "#7DC462",
    strokeMiterlimit: 10,
    strokeWidth: "8px"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M225.35,356.43c183.42-78,371.14-79.06,555.94,0,17.53,7.5,17.43,139.87,0,133.81-180.47-62.83-371.33-63.5-555.94,0C203.39,497.79,205.53,364.86,225.35,356.43Z",
    fill: "none",
    stroke: "#592d3d",
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M426.76,283.72A328.8,328.8,0,0,1,465.37,278c3.25-.28,6.49-.56,9.74-.78l9.75-.56c3.26-.14,6.51-.2,9.77-.3l9.77-.13c13,0,26.05.63,39,1.84a324.4,324.4,0,0,1,38.6,5.8c-13-.29-26-.79-38.88-1.13s-25.84-.49-38.75-.52h-9.68c-3.23,0-6.46.12-9.69.11l-9.68.14c-3.23.11-6.46.16-9.7.2C452.72,283,439.78,283.46,426.76,283.72Z",
    fill: "#592d3d"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M347.31,233.83a183.71,183.71,0,0,1,22.38-15.33c7.78-4.62,15.81-8.84,24-12.66,2-1,4.13-1.86,6.2-2.78s4.13-1.86,6.24-2.67c4.22-1.65,8.4-3.38,12.7-4.8a217,217,0,0,1,26.06-7.5c-2.07.91-4.16,1.78-6.25,2.63s-4.19,1.64-6.25,2.56c-4.15,1.74-8.31,3.42-12.43,5.22l-3.09,1.33c-1,.43-2.08.85-3.1,1.32l-6.15,2.73c-2.06.88-4.09,1.83-6.14,2.75s-4.09,1.84-6.1,2.83l-6.1,2.83c-2,1-4,2-6.05,3-4,1.94-8,4-12.05,6C363.19,225.31,355.23,229.48,347.31,233.83Z",
    fill: "#ffffff"
  }))), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 382.91,
    cy: 594.66,
    r: 33.84,
    fill: "#ffffff",
    opacity: 0.2
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M375.87,631l43.31-41.74a147.47,147.47,0,0,0-7.57-12.9l-45.87,44.21C367.64,621.9,373.72,630.08,375.87,631Z",
    fill: "#ffffff",
    opacity: 0.4
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 382.91,
    cy: 594.66,
    r: 33.84,
    fill: "none",
    stroke: "#592d3d",
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M378,580.47c1.22,3.83-3.5,6.78-7,7.37-3.54,0-5.9-2.36-7.08-5.31-.59-2.95,0-5.9,2.36-7.67,2.95-1.18,7.08-2.36,9.7.67A6.85,6.85,0,0,1,378,580.47Z",
    fill: "#ffffff"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M384.32,578.21a2.29,2.29,0,0,1-4.49.19c0-1.77.59-2.36,2.27-2.42a2.22,2.22,0,0,1,2.22,2.22Z",
    fill: "#ffffff"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 615.2,
    cy: 594.66,
    r: 33.84,
    fill: "#ffffff",
    opacity: 0.2
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M610.12,628.11l38.54-38.54c-.21-1.37-5.91-8.1-6.29-9.44l-41.72,41.74C602,622.24,608.75,627.91,610.12,628.11Z",
    fill: "#ffffff",
    opacity: 0.4
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 615.2,
    cy: 594.66,
    r: 33.84,
    fill: "none",
    stroke: "#592d3d",
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M607.36,579.91c1,3.25-3,5.75-6,6.25-3,0-5-2-6-4.5-.5-2.5,0-5,2-6.5,2.5-1,6-2,8.23.57A5.85,5.85,0,0,1,607.36,579.91Z",
    fill: "#ffffff"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M612.7,578a1.94,1.94,0,0,1-3.8.16c0-1.5.5-2,1.92-2A1.88,1.88,0,0,1,612.7,578Z",
    fill: "#ffffff"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M416.74,594.66q83.68-30,164.63,0",
    fill: "none",
    stroke: "#592d3d",
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M615.2,634.5A39.9,39.9,0,0,1,575.6,599c-50-17.65-101.46-17.64-153.1,0a39.81,39.81,0,0,1-50.92,33.84,38,38,0,0,0,54.51-29.91c49.22-16.86,98.28-16.88,145.93,0a38,38,0,0,0,54.51,30A40,40,0,0,1,615.2,634.5Z",
    opacity: 0.15
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBighead7);
export default __webpack_public_path__ + "static/media/bighead-7.a86295610ee963f5d6184a106b3dafb4.svg";
export { ForwardRef as ReactComponent };